var chunkMapping = {
	"1051": [
		1051
	],
	"1596": [
		1596
	],
	"2435": [
		2435
	],
	"3231": [
		5612
	],
	"3369": [
		3369
	],
	"3464": [
		3464
	],
	"5786": [
		5786
	],
	"6639": [
		6639
	],
	"6921": [
		6921
	],
	"7343": [
		7343
	],
	"7998": [
		7525,
		5271,
		9166
	],
	"8803": [
		8803
	]
};
var idToExternalAndNameMapping = {
	"1051": [
		"default",
		"./mancity/template",
		1005
	],
	"1596": [
		"default",
		"./generic/components/cards/card-news",
		1005
	],
	"2435": [
		"default",
		"./generic/components/general/card-slider",
		1005
	],
	"3369": [
		"default",
		"./generic/components/general/rich-text",
		1005
	],
	"3464": [
		"default",
		"./generic/components/cards/player-card",
		1005
	],
	"5271": [
		"default",
		"./generic/elements/icons",
		1005
	],
	"5612": [
		"default",
		"./generic/components/navigation/sub-header",
		1005
	],
	"5786": [
		"default",
		"./mancity/components/general/seo",
		1005
	],
	"6639": [
		"default",
		"./players/components/hero-player",
		1005
	],
	"6921": [
		"default",
		"./generic/elements/loading",
		1005
	],
	"7343": [
		"default",
		"./generic/elements/button",
		1005
	],
	"7525": [
		"default",
		"./generic/components/general/tabs",
		1005
	],
	"8803": [
		"default",
		"./generic/components/navigation/pagination",
		1005
	],
	"9166": [
		"default",
		"./generic/elements/divider",
		1005
	]
};
var idToRemoteMap = {
	"1051": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"1596": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"2435": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3369": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3464": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5612": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5786": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6639": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6921": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7343": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7525": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"8803": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9166": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"1051": {
		"shareScope": "default",
		"name": "./mancity/template",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"1596": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-news",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"2435": {
		"shareScope": "default",
		"name": "./generic/components/general/card-slider",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"3369": {
		"shareScope": "default",
		"name": "./generic/components/general/rich-text",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"3464": {
		"shareScope": "default",
		"name": "./generic/components/cards/player-card",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5612": {
		"shareScope": "default",
		"name": "./generic/components/navigation/sub-header",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5786": {
		"shareScope": "default",
		"name": "./mancity/components/general/seo",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"6639": {
		"shareScope": "default",
		"name": "./players/components/hero-player",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"6921": {
		"shareScope": "default",
		"name": "./generic/elements/loading",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"7343": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"7525": {
		"shareScope": "default",
		"name": "./generic/components/general/tabs",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"8803": {
		"shareScope": "default",
		"name": "./generic/components/navigation/pagination",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"9166": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 1005,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}